export const environment = {
    production: true,
    apiUrl: "https://kikovpn.com/api",
    sslczLink: "https://sandbox.sslcommerz.com/embed.min.js?",
    sslczPaymentAPI: "https://sandbox.sslcommerz.com/gwprocess/v4/api.php",
    sslczID: "kikov67c88b9358091",
    sslczPass: "kikov67c88b9358091@ssl",
};
